import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";
import { normalizeQuestions, Questionnaire } from "../../types/Questionnaire";

export const uploadQuestionnaire = async (
  communityId: string,
  questionnaire: Questionnaire
): Promise<void> => {
  if (!communityId) {
    console.error("communityId is required to upload questionnaire");
    return;
  }

  const docRef = firestore
    .collection(DB_PATH.COMMUNITY)
    .doc(communityId)
    .collection(DB_PATH.ONBOARDING)
    .doc("questionnaire_metadata");

  try {
    await docRef.set({
      ...questionnaire,
      questions: normalizeQuestions((questionnaire as any)?.questions),
    });
    console.log("Questionnaire uploaded successfully");
  } catch (error) {
    console.error("Error uploading questionnaire: ", error);
  }
};
